import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { IonNav } from '@ionic/angular';
import { PlatformEnum } from '@panamax/app-state';
import { SortFields, SortType } from '@payments/models/state-model';
import {
  ModalSort,
  ModalSortOptionsData,
} from '@shared/components/usf-filtering-modal/model/modal-filter';
import { UsfFilteringOptionComponent } from '@shared/components/usf-filtering-modal/usf-filtering-options/usf-filtering-option/usf-filtering-option-component';
import { SortDirection, SortFilter } from '@usf/ngrx-payment';

@Component({
  selector: 'app-usf-sort-options',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './usf-sort-options.component.html',
  styleUrls: ['./usf-sort-options.component.scss'],
})
export class UsfSortOptionsComponent
  extends UsfFilteringOptionComponent<ModalSortOptionsData, SortFilter[]>
  implements OnInit {
  @Input() sortOptions: ModalSort[];
  @Input() sortSelection: SortFilter[];

  readonly SortDirection = SortDirection;
  readonly SortFields = SortFields;
  readonly PlatformEnum = PlatformEnum;

  constructor(public ionNav: IonNav) {
    super(ionNav);
  }

  sortDirection = SortDirection.DESC;

  ngOnInit(): void {
    this.sortSelection =
      this.data.sortSelection.length === 1
        ? this.data.sortSelection
        : [this.data.sortSelection[0]];
  }

  isAsc(sortOption: SortDirection): boolean {
    return sortOption === SortDirection.ASC;
  }

  sort(field: SortType) {
    if (this.sortSelection[0].fieldName === field) {
      this.sortDirection =
        this.sortDirection === SortDirection.ASC
          ? SortDirection.DESC
          : SortDirection.ASC;
    } else {
      const { sortDirection: defaultDirection } = this.data.sortOptions.find(
        option => option.sortName === field,
      );
      this.sortDirection = defaultDirection;
    }

    this.sortSelection = [{ fieldName: field, sortValue: this.sortDirection }];

    if (this.data.platformType === PlatformEnum.tablet) {
      this.saveSort();
    }
  }

  saveSort() {
    this.data.sortSelection = this.sortSelection;
    this.optionSelected.emit(this.sortSelection);
    if (this.data.platformType === PlatformEnum.mobile) {
      this.navigateBack();
    }
  }
}
